module.exports = __webpack_public_path__ + "static/media/edit-onclick.fb611a9a.svg";